import ReportsGrid from './reports-grid';
import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import { Outlet } from 'react-router-dom';

export default function ReportsPage() {
  const { toolsRoles, changeLogRoles, usersTier } = useUserSettings();

  const isFormPage = useRouteMatch([
    `${pagesConfig.reports.link}/${pagesConfig.createReport.link}`,
    `${pagesConfig.reports.link}/${pagesConfig.editReport.link}`,
  ]);
  if (isFormPage) return <Outlet />;
  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.reportCenter.name },
        { label: pagesConfig.reports.name },
      ]}
      bookmarkKey={pagesConfig.reports.value}
    >
      <ReportsGrid
        toolsRoles={toolsRoles}
        changeLogRoles={changeLogRoles}
        usersTier={usersTier}
      />
    </SimpleBreadcrumbsPage>
  );
}
